import styled from 'styled-components';

import colors from '@theme/colors';

export const Message = styled.p`
  font-size: 24px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: -0.32px;
  color: ${({ dark }) =>
    dark ? colors['very-light-brown'] : colors['charcoal']};
`;
